import { call, put, takeLatest, takeLeading } from 'redux-saga/effects';
import UserRoleService from '../api/userRole';
import { userRoleActions } from '../reducers/user-role';

function* getAllRoleList({ payload }: any): any {
  const res = yield call(UserRoleService.fetchRoleList, payload);
  if (res.status === 'success') {
    yield put(userRoleActions.getRoleListResponse(res));
  } else {
    yield put(userRoleActions.getRoleListFailed(res?.code));
  }
}

function* addRoleCall({ payload }: any): any {
  const res = yield call(UserRoleService.addNewRole, payload);
  if (res.status === 'success') {
    yield put(userRoleActions.addRoleResponse(res.code));
  } else {
    yield put(userRoleActions.addRoleRequestFailed(res?.code));
  }
}

function* deleteRoleCall({ payload }: any): any {
  const res = yield call(UserRoleService.deleteRoles, payload);
  if (res.status === 'success') {
    yield put(userRoleActions.deleteMultipleRoleResponse(res.code));
  } else {
    yield put(userRoleActions.deleteMultipleRoleFailed(res?.code));
  }
}

function* getRoleAccessList({ payload }: any): any {
  const res = yield call(UserRoleService.fetchRoleAccessList, payload);
  if (res.status === 'success') {
    yield put(userRoleActions.getRoleAccessListResponse(res));
  } else {
    yield put(userRoleActions.getRoleAccessListFailed(res?.code));
  }
}

function* updateRoleAccessCall({ payload }: any): any {
  const res = yield call(UserRoleService.updateRoleAccessList, payload);
  if (res.status === 'success') {
    yield put(userRoleActions.updateRoleAccessResponse(res.code));
  } else {
    yield put(userRoleActions.updateRoleAccessFailed(res?.code));
  }
}

function* UserRoleSaga() {
  yield takeLatest('userRoleManagement/getRoleList', getAllRoleList);
  yield takeLeading('userRoleManagement/addRoleRequest', addRoleCall);
  yield takeLeading('userRoleManagement/deleteMultipleRoleRequest', deleteRoleCall);
  yield takeLeading('userRoleManagement/getRoleAccessList', getRoleAccessList);
  yield takeLeading('userRoleManagement/updateRoleAccessRequest', updateRoleAccessCall);
}

export default UserRoleSaga;
